module.exports = __webpack_public_path__ + "static/logo-33c6ad8e784723152d818baebaf004db.png";